export const environment = {
  production: false,
  BaseUrlBE: "https://gp-online.besidetech.it/api//",
  UsersBaseUrl: "https://gp-online.besidetech.it/api//users",
  TemplateBaseUrl: "https://gp-online.besidetech.it/api//template",
  CustomersBaseUrl: "https://gp-online.besidetech.it/api//customers",
  GiuridicTypeBaseUrl: "https://gp-online.besidetech.it/api//giuridictype",
  PaymentMethodBaseUrl: "https://gp-online.besidetech.it/api//paymentMethod",
  PreventiviMethodBaseUrl: "https://gp-online.besidetech.it/api//preventivo",
  PrezzoImballoMethodBaseUrl: "https://gp-online.besidetech.it/api//prezzoImballo",
  CopiaLavorazioneMethodBaseUrl: "https://gp-online.besidetech.it/api//copia_lavorazione",
  ClausolePreventivoUrl: "https://gp-online.besidetech.it/api//clausolepreventivo",
  SistemiDiPagamentoUrl: "https://gp-online.besidetech.it/api//coordinatebancarie",
  CaricoVirtualeMethodBaseUrl: "https://gp-online.besidetech.it/api//carico_virtuale",
  CambioPrezzoMethodBaseUrl: "https://gp-online.besidetech.it/api//cambio-prezzi",
  PercentualiMethodBaseUrl: "https://gp-online.besidetech.it/api//percentuali",
  ordineBaseUrl: "https://gp-online.besidetech.it/api//ordine",
  baseUrl: "https://gp-online.besidetech.it",
  loginUrl: "https://gp-online.besidetech.it/login",
  keycloakUrl: "https://auth.besidetech.it/",
  keycloackLocale: "it",
  MagazzinoMethodBaseUrl: "https://gp-online.besidetech.it/api//magazzino",
  wsUrl: 'https://gp-online.besidetech.it/api//ws',
  apiUrl: 'https://gp-online.besidetech.it/api//api/'
};
